import styled from 'styled-components';
import { Col, Button, Label, Input, TabContent, FormGroup, UncontrolledDropdown, DropdownToggle } from 'reactstrap';
import { PrimaryColor, WhiteColor, SecondaryColor, LightGrayColor } from '_variable';
import Select from 'react-select';
import 'primereact/resources/themes/saga-blue/theme.css'; // PrimeReact theme
import 'primereact/resources/primereact.min.css'; // PrimeReact core CSS

export const MarginCol = styled(Col)`
    ${(props) => `margin :` + props.contentmargin}
`;

export const AutomationInputHeader = styled(Input)`
  background-color: transparent;
  border-color: transparent;
  color: white;
  font-size: 16px;
  font-weight: bold;
  color: var(--quarternary);
  &:placeholder-shown {
     font-style: italic;
  }
   font-style: italic;
`

export const AutomationTabContent = styled(TabContent)`
  .automation-bg {
    background-color: var(--lightPrimaryRoi);
    border: none;
  }

  .rounded-pill {
    border-radius: 8px !important;
  }

  height : 100%;

  .sidebar-header {
    text-align: left;
    font-size: 18px;
    border-bottom: 1px solid;
    color: var(--lightColorRoi);
    margin-bottom: 20px;
    padding: 15px 10px 10px 10px;
    font-family: 'Roboto';
  }

  .icon-minimize {
    float: right;
    margin-top: 5px;
    cursor: pointer;
    transition: 0.2s;
    font-size : 16px;
  }

  .icon-minimize:hover {
    color: var(--primary);
  }

  .step-menu {
    background: var(--quarternary);
  }

  .step-icon {
    width: 30px;
    margin-right: 6px;
  }

  .step-title {
    font-weight: bold;
    padding: 13px 0;
    color: var(--lightColorRoi);
  }

  .step-option {
    margin: 20px 0px;
    color: var(--lightColorRoi);
    cursor: pointer;
    transition: 0.2s;
    font-size: 16px;
  }

  .step-body-text {
    margin: 17px 0px;
    color: var(--lightColorRoi);
    cursor: pointer;
    transition: 0.2s;
    font-size: 12px;
  }

  .segment-title {
    margin: 17px 0px;
    color: var(--lightColorRoi);
    cursor: pointer;
    transition: 0.2s;
    font-size: 13px;
  }

  .step-option:hover {
    margin: 20px 0px;
    color: var(--primary);
  }

  .automation-button-finalise {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 15px;
  }

  .automation-finalise-input-field {
    background-color: transparent;
    border-color: transparent;
  }

  .automation-to-finalise {
    color: #5c6873;
    padding-left: 1rem;
  }

  .automation-back-button {
    background: transparent;
    font-size: 20px;
    font-weight: bold;
    border: none;
  }

  .automation-back-icon {
    transition: .2s;
    cursor: pointer;
  }

  .automation-back-icon:hover {
    color: var(--primary);
  }

  .automation-form-input {
    min-width: 55px;
    margin: 0 -5px;
  }

  .automation-form-input-time {
    min-width: 55px;
  }

  .show-list-data {
    padding: 0.5rem 1.2rem !important;
    background-color: var(--fontHeaderGridRoi) !important;
    border-color: var(--fontHeaderGridRoi) !important;
    color: var(--lightPrimaryRoi) !important;
    border-radius: 50px !important;
  }

  .show-list-data button {
    padding: 0.35rem 1.2rem !important;
    opacity: 1 !important;
  }

  .show-list-data span {
    color: white !important;
  }

  .alert-custom {
    min-width: 100px !important;
    display: inline-block !important;
    margin-right: 5px !important;

    div {
        width : 100%;
        margin-right : 15px;
    }
  }

  .automation-dropdown__control, .automation-dropdown__menu, .automation-dropdown__menu-list, .automation-operator-dropdown__menu, .automation-operator-dropdown__menu-list {
    border: none !important;
    border-radius: 8px !important;
    background: #222 !important;
    color: var(--lightPrimaryRoi) !important;
    box-shadow: none !important;
  }

  .candidate-skills-hierarchy {
    width: 100%;
    min-height: 38px;
    font-size: 13px;
    border: none !important;
    border-radius: 8px !important;
    background: #222 !important;
    color: var(--lightPrimaryRoi) !important;
    box-shadow: none !important;
  }

  .candidate-skills-hierarchy .p-treeselect-panel {
    background: #222 !important;
    color: var(--lightPrimaryRoi) !important;
  }

  .candidate-skills-hierarchy .p-treeselect-header {
    background: #222 !important;
    color: var(--lightPrimaryRoi) !important;
    display: flex;
    justify-content: end;
  }

  .candidate-skills-hierarchy .p-treeselect-close:hover {
    background: #222 !important;
    color: var(--primary);
  }

  /* Tree styling */
  .candidate-skills-hierarchy .p-tree {
    background: #222 !important;
    color: var(--lightPrimaryRoi) !important;
  }

  .candidate-skills-hierarchy .p-treenode-content:hover,
  .candidate-skills-hierarchy .p-treenode-content.p-highlight {
    background-color: #444;
    color: var(--lightPrimaryRoi) !important;
    transition: background-color 0.2s ease;
  }

  .candidate-skills-hierarchy .p-tree-toggler:hover {
    background-color: #444;
    color: #6c757d !important;
  }

  .candidate-skills-hierarchy .p-checkbox-box[data-p-highlight="true"] {
    border-color: var(--primary);
    background-color: var(--primary);
  }

  .candidate-skills-hierarchy .p-checkbox-box[data-p-highlight="false"] {
    border: 1.5px solid #555;
    background-color: transparent;
  }

  .candidate-skills-hierarchy .selected-skills {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }

  .candidate-skills-hierarchy .selected-skill {
    display: inline-flex;
    align-items: center;
    background-color: #333;
    border: 1px solid #444;
    border-radius: 4px;
    padding: 2px 8px;
    font-size: 0.8rem;
    color: var(--lightPrimaryRoi);
    margin-right: 5px;
    margin-bottom: 3px;
    white-space: nowrap;
  }

  .candidate-skills-hierarchy .selected-skill-remove {
    margin-left: 5px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--primary);
    background: transparent;
    border: none;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.8;
    }
  }

  .automation-dropdown__control--is-disabled {
    background-color : #3B3A3A !important;
    color : gray !important;
  }

  .automation-dropdown__single-value {
    color: #fff !important;
  }

  .automation-dropdown__option:hover, .automation-dropdown__option--is-selected, .automation-dropdown__option--is-focused, .automation-dropdown__option:active, .automation-operator-dropdown__option:hover, .automation-operator-dropdown__option--is-selected, .automation-operator-dropdown__option--is-focused, .automation-operator-dropdown__option:active {
    background: var(--primary) !important;
  }

  .automation-dropdown__indicator-separator, .automation-operator-dropdown__indicator-separator {
    width: 0 !important;
  }

  .automation-operator-dropdown__control {
    border: none !important;
    border-radius: 20px !important;
    background: var(--primary) !important;
    color: #FFFFFF !important;
    box-shadow: none !important;
  }

  .automation-operator-dropdown__single-value, .automation-operator-dropdown__placeholder, .automation-operator-dropdown__dropdown-indicator {
    color: #FFFFFF !important;
  }

  .automation-operator {
    margin: 0 auto;
    width: 105px;
  }

  .automation-form-dropdown-multi {
    font-size: 14px;
    background-color: #222;
    color: var(--lightPrimaryRoi);
    border: none;
    border-radius: 20px;
  }

  .automation-form-dropdown-multi .automation-dropdown__multi-value__label, .automation-form-dropdown-multi .automation-dropdown__single-value {
    background-color: #222;
    color: var(--lightPrimaryRoi);
    border-radius: 0;
  }

  .automation-form-dropdown-multi .automation-dropdown__multi-value__remove {
    background-color: #222;
    color: red;
    border-radius: 0;
  }

  .automation-form-dropdown-multi .automation-dropdown__clear-indicator {
    display: none;
  }

  .automation-form-dropdown-multi .css-b8ldur-Input, .automation-ifelse-third-column .css-b8ldur-Input {
    color: var(--lightPrimaryRoi)
  }

  .automation-alert-input, .automation-alert-input:focus, .automation-ifelse-third-column, .automation-ifelse-third-column:focus, .automation-form-input, .automation-form-input:focus, .automation-form-input-time, .automation-form-input-time:focus, .automation-email-input, .automation-email-input:focus, .automation-email-domain {
    color: var(--lightPrimaryRoi);
    background-color: #222;
    border: none;
  }

  .automation-date-input, .automation-date-input:focus {
    color: var(--lightPrimaryRoi);
    background-color: #222;
    border: none;
    border-radius: 8px;
    font-size: 12px;
    color-scheme: dark;
  }

  .automation-form-dropdown-multi .automation-dropdown__multi-value__label {
    white-space: normal;
  }

  .automation-dropdown__control--is-disabled {
    background-color: #3B3A3A !important;
    color: grey !important;

    .automation-dropdown__multi-value__label, 
    .automation-dropdown__multi-value__remove, 
    .automation-dropdown__single-value--is-disabled {
      background-color: #3B3A3A !important;
      color: grey !important;
    }
  }

  .automation-form-input-time:disabled, 
  .input-within-last:disabled, 
  .automation-email-input:disabled, 
  .input-delay:disabled,
  .automation-alert-input:disabled,
  .custom-input-dropdown__control--is-disabled,
  .automation-form-dropdown-multi:disabled {
    background-color: #3B3A3A !important;
    color: grey !important;
  }

  .automation-operator-remove {
    color: var(--danger-color);
    margin-right: 15px;
  }

  .automation-add-operator {
    background-color: var(--white);
    color: var(--black);
  }

  .automation-email-domain {
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px;
    background-color: var(--primary);
  }

  .automation-email-input-form-email {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }

  .automation-trigger-matching-loading {
    display: block;
    margin: 0 auto;
    color: white;
  }

  .automation-trigger-matching-text, .automation-trigger-matching-text:hover {
    font-size: 14px;
    margin-bottom: 0;
    color: var(--lightColorRoi);
  }

  .automation-trigger-matching-number, .automation-trigger-matching-number:hover {
    font-size: 16px;
    color: var(--primary);
  }

  /* Chrome, Safari, Edge, Opera */

  input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */

  input[type=number] {
    -moz-appearance: textfield;
  }

  .container-fluid .tab-content {
    height: 100%;
  }

  .textarea-form {
    height: 94px !important;
  }

  .textarea-form:focus {
    background-color: #222;
    color: var(--lightPrimaryRoi);
  }

  /* automation time input */
  .automation-finalise-input-hours {
    background-color: transparent;
    border-left: 0;
    border-top: 0;
    border-right: 0;
    border-radius: 0;
    text-align: left;
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    line-height: 1.5;
    color: #222;
  }

  .automation-finalise-input-hours:hover, .automation-finalise-input-hours:active {
    background-color: transparent !important;
    color: #222 !important;
    border-radius: 0;
  }
 
  .automation-story-sidebar-input-hours {
    background-color: ${WhiteColor};
    border: 0;
    text-align: left;
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    line-height: 2.5;
    color: #222;
  }

  .automation-story-sidebar-input-hours:hover, .automation-story-sidebar-input-hours:active {
    background-color: ${WhiteColor} !important;
    color: #222 !important;
    border-radius: 0;
  }

  .automation-finalise-time>.react-datepicker-wrapper {
    width: 75%;
  }

  .automation-finalise-time .react-datepicker-wrapper .btn {
    height: 25px;
    padding-bottom: 25px !important;
  }

  /* automation manage */
  .automation-manage {
    padding: 0 !important;
  }
  .automation-manage:focus,
  .automation-manage:active {
    border: 0 !important;
  }

  .btn-group-automation-switch-content {
    width: 100%;
  }
  .btn-automation-switch-content {
    border-radius: 0;
  }

  .ag-center-cols-container {
    width: 100% !important;
  }

  /* Region Automation Manage custom styling */
  .nav-tabs .nav-link.automation-grid {
    color: gray !important;
    border: none !important;
  }

  .nav-tabs .nav-link.active.automation-grid {
    color: var(--white) !important;
    background-color: var(--secondary-color) !important;
    border: none !important;
  }

  .margin-y-1rem {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  /* Region Automation Add To Job search/list styling */
  .automation-jobs-search-wrap {
    position: relative;
  }

  .automation-jobs-search-input {
    padding-left: 34px !important;
    padding-right: 34px !important;
  }

  .automation-jobs-search-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: ${LightGrayColor};
    font-size: 12px;
    pointer-events: none;
  }

  .automation-jobs-search-spinner {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: ${LightGrayColor};
    font-size: 13px;
  }

  .automation-jobs-search-clear {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: ${LightGrayColor};
    font-size: 13px;
    cursor: pointer;
  }

  .automation-jobs-search-clear:hover {
    color: ${WhiteColor};
  }

  .automation-jobs-selected-label {
    display: block;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${LightGrayColor};
    margin-bottom: 4px;
  }

  .automation-jobs-selected-chip {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 8px;
    background-color: rgba(239, 66, 119, 0.12);
    border: 1px solid ${PrimaryColor};
  }

  .automation-jobs-selected-chip-check {
    flex-shrink: 0;
    color: ${PrimaryColor};
    font-size: 12px;
  }

  .automation-jobs-selected-chip-body {
    flex: 1;
    min-width: 0;
  }

  .automation-jobs-selected-chip-title {
    color: ${WhiteColor};
    font-size: 13.5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .automation-jobs-selected-chip-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 10px;
    font-size: 11.5px;
    color: ${LightGrayColor};
    margin-top: 2px;
  }

  .automation-jobs-selected-chip-remove {
    flex-shrink: 0;
    color: ${LightGrayColor};
    font-size: 12px;
    cursor: pointer;
  }

  .automation-jobs-selected-chip-remove:hover {
    color: ${WhiteColor};
  }

  .automation-jobs-list-container {
    border: 1px solid #444;
    border-radius: 6px;
    background-color: ${SecondaryColor};
    max-height: 380px;
    overflow-y: auto;
  }

  .automation-jobs-list-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-bottom: 1px solid #333;
    color: ${WhiteColor};
  }

  .automation-jobs-list-item:last-child {
    border-bottom: none;
  }

  .automation-jobs-list-item-selectable {
    cursor: pointer;
  }

  .automation-jobs-list-item-selectable:hover {
    background-color: #333;
  }

  .automation-jobs-list-item-selected {
    background-color: rgba(239, 66, 119, 0.12);
  }

  .automation-jobs-list-item-radio {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 1px solid ${LightGrayColor};
  }

  .automation-jobs-list-item-selected .automation-jobs-list-item-radio {
    border-color: ${PrimaryColor};
    background-color: ${PrimaryColor};
  }

  .automation-jobs-list-item-body {
    flex: 1;
    min-width: 0;
  }

  .automation-jobs-list-item-title {
    font-size: 13.5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .automation-jobs-list-item-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 10px;
    font-size: 11.5px;
    color: ${LightGrayColor};
    margin-top: 2px;
  }

  .automation-jobs-list-item-check {
    flex-shrink: 0;
    color: ${PrimaryColor};
    font-size: 12px;
  }

  .automation-jobs-list-empty {
    padding: 40px 20px;
    text-align: center;
    color: #888;
  }

  .automation-jobs-list-search-limit-warning {
    margin-top: -8px;
    margin-bottom: 10px;
    font-size: 0.85em;
  }

  .automation-jobs-list-cap-hint {
    margin-top: 6px;
    font-size: 0.8em;
    color: ${LightGrayColor};
    text-align: center;
  }
`

export const DatepickerButton = styled(Button)`
    color : #707070 !important;
    font-size : 12px !important;
    border : solid 1px #707070;
`;

export const DateFormGroup = styled(FormGroup)`
  display : inherit;
  padding : 5px 35px 5px 35px;
`

export const AutomationDateSpan = styled.div`
   font-family : 'Roboto';
   font-size : 12px;
   width : 55px;

   input {
      ${(props) => props.checked && `color : #707070;`}
   }

   label::before {
     height : 14px !important;
     font-size : 10px !important;
     background-color : ${PrimaryColor} !important;
     padding : 2px !important;
   }

   @media (max-width : 450px) {
       margin-left : 1px !important;
   }

   @media (max-width : 360px) {
       margin-left : 1px !important;
   }

   @media (max-width : 900px) {
       margin-left : 1px !important;
   }
`;

export const AutomationDateCheckbox = styled(Input)`
   font-family : 'Roboto';
   font-size : 12px;
`;

export const HeaderSaveButton = styled(Button)`
    ${(props) => !props.isblack && `
      background-color : white !important;
      color : var(--dark) !important;
      &:hover {
        background-color : var(--secondary) !important;
      }
      `
  }
`;

export const AutomationLabelSchedule = styled(Label)`
    font-family : 'Roboto';
    font-size : 12px;
    color : #707070;
`;

export const SelectButton = styled(Button)`
    background-color : white !important;
    color : var(--secondary) !important;
    font-size : .875rem;
    font-family : 'Roboto';
    &:hover {
      background-color : var(--secondary) !important;
      color : var(--white) !important;
    }
`;

export const AutomationItem = styled.div`
    div {
      font-family: 'Roboto';
      font-size : 12px;

      img {
         width : 28px;
      }
    }
`;

export const TextCount = styled(Label)`
    position: absolute;
    right: 34px;
    bottom: 31px;
    color: #5C6570;
`;


export const TotalTime = styled.div`
    font-size: 10px;
    text-align: center;
    margin-top: 15px;
`;

export const ButtonDropdown = styled(UncontrolledDropdown)`
    button {
        width: 200px;
        border-radius: 10px;
    }

    div.dropdown-menu {
      border-radius: 10px;
      margin-top : 5px;
    }

    button.dropdown-toggle {
      border-radius: 40px;
      background-color: ${PrimaryColor};

      :focus {
        background-color: ${PrimaryColor};
      }

      :click {
        background-color: ${PrimaryColor};
      }
    }

    &.dropdown.show {
       button {
         background-color: ${PrimaryColor};
       }
    }

    button.dropdown-item:hover {
      border-radius: 10px;
      background-color: ${PrimaryColor};
      color: ${WhiteColor};
    }
`;
export const HeaderButtonDropdown = styled(UncontrolledDropdown)`
    button {
        width: 150px;
    }
`;

export const PersonalDropdownToggle = styled(DropdownToggle)`
  background-color : ${SecondaryColor};
  border-color : ${SecondaryColor};
  font-family : 'Roboto';

  &.primary {
      background-color : ${PrimaryColor};
  }
`;

export const EmailEditorButton = styled(Button)`
  margin-top : 0px !important;
  padding : 4px 10px 4px 10px !important;
  font-size : 0.875rem !important;
`

export const SwitchContainer = styled.div`
  height : 42px !important;
  padding-top : 5px;
`

export const SwitchLabel = styled(Label)`
  position: absolute;
  top: 1px;
  margin-left: 10px;
`
export const SidebarFormSelect = styled(Select)`
    font-size : 0.875rem !important;

    .automation-dropdown__control {
      min-height : 0px !important;
    }
`

export const LabelField = styled(Label)`
    font-family : 'Roboto';
    font-size : 12px;
    color : ${WhiteColor};
`;

export const RadioAutomation = styled(Input)`
    &:after {
      width: 15px;
      height: 15px;
      border-radius: 15px;
      top: -2px;
      left: -1px;
      position: relative;
      background-color: ${WhiteColor};
      content: '';
      display: inline-block;
      visibility: visible;
      border: 2px solid ${LightGrayColor};
    }

    &:checked:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background-color: ${PrimaryColor};
        content: '';
        display: inline-block;
        visibility: visible;
        border: 2px solid ${LightGrayColor};
    }
`

export const CustomCol = styled(Col)`
  &.disabled {
      color : ${LightGrayColor};
  }
`

export const SenderSectionContainer = styled.div`
  margin: 24px 0 0 0;
`;

export const SenderSectionTitle = styled.div`
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 16px;
  opacity: 0.9;
`;

export const SendFromContainer = styled.div`
  margin: 20px 0 16px 0;
`;

export const SendFromLabel = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 16px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  }

  &::before {
    margin-right: 16px;
  }

  &::after {
    margin-left: 16px;
  }
`;

export const SendFromButtonGroup = styled.div`
  display: flex;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 4px;
  gap: 4px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);
`;

export const SendFromButton = styled.button`
  flex: 1;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;
  color: ${props => props.isSelected ? '#ffffff' : 'var(--lightColorRoi)'};
  background: ${props => props.isSelected 
    ? 'linear-gradient(135deg, rgba(239, 66, 119, 0.9) 0%, rgba(239, 66, 119, 0.7) 100%)' 
    : 'transparent'};
  border: ${props => props.isSelected ? '1px solid var(--primary)' : '1px solid transparent'};
  border-radius: 6px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: ${props => props.disabled ? 0.4 : 1};
  white-space: nowrap;
  position: relative;
  overflow: hidden;

  ${props => props.isSelected && `
    box-shadow: 
      0 2px 8px rgba(239, 66, 119, 0.3),
      0 1px 3px rgba(0, 0, 0, 0.2);
    transform: translateY(-1px);
  `}

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 100%);
    opacity: 0;
    transition: opacity 0.25s ease;
  }

  &:hover {
    ${props => !props.disabled && !props.isSelected && `
      background: rgba(255, 255, 255, 0.08);
      border-color: rgba(255, 255, 255, 0.15);
      transform: translateY(-1px);
    `}
    
    ${props => !props.disabled && props.isSelected && `
      &::before {
        opacity: 1;
      }
    `}
  }

  &:active {
    ${props => !props.disabled && `
      transform: translateY(0);
    `}
  }

  ${props => props.isSelected && `
    padding-right: 32px;

    &::after {
      content: '✕';
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 12px;
      opacity: 0.8;
      font-weight: bold;
      transition: opacity 0.2s ease, transform 0.2s ease;
    }

    &:hover::after {
      opacity: 1;
      transform: translateY(-50%) scale(1.1);
    }
  `}
`;

export const SendFromDropdownContainer = styled.div`
  margin-top: 12px;
  animation: slideDown 0.3s ease;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

// ROI-235 email "Send from": one mode is always selected, so no clear mark on the selected button.
export const SenderModeButton = styled(SendFromButton)`
  && {
    flex: 1 1 0;
    min-width: 0;
    min-height: 40px;
    padding: 6px 6px;
    font-size: 12px;
    line-height: 1.2;
    white-space: normal;
    text-align: center;
    overflow: visible;
  }

  &&::after {
    content: none;
  }

  /* The hover sheen covers the whole button and would swallow clicks on the owner caret (ROI-440). */
  &&::before {
    pointer-events: none;
  }
`;

export const SenderModeSplit = styled.div`
  flex: 1;
  display: flex;
  min-width: 0;
  position: relative;

  & > .dropdown {
    display: flex;
    width: 100%;
  }

  & > .dropdown > [role="radio"] {
    width: 100%;
    flex-wrap: wrap;
    gap: 2px 4px;
  }

  & .dropdown-menu {
    min-width: 200px;
    padding: 6px;
    background: #1b1b1b;
    border: 1px solid #444444;
    border-radius: 10px;
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.45);
  }

  & .dropdown-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px;
    border-radius: 8px;
    color: #ffffff;
    font-size: 14px;
  }

  & .dropdown-item:hover,
  & .dropdown-item:focus,
  & .dropdown-item.active {
    background: #333333;
    color: #ffffff;
  }

  & .dropdown-item .fa-check {
    color: #e58aa6;
  }
`;

export const SenderModeCaret = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.12);
  font-size: 11px;
`;

export const SenderFromCard = styled.div`
  margin-top: 14px;
  padding: 12px 14px;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SenderFromCardLabel = styled.div`
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
`;

export const SenderFromName = styled.div`
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  word-break: break-word;
`;

export const SenderFromDetail = styled.div`
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  word-break: break-word;
`;

// ROI-234 email step: Scheduling & Delivery accordion, its two single-select options and the
// compact weekday pills.
export const DeliveryAccordionHeader = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 32px;
  margin-bottom: 16px;
  padding: 0 0 8px;
  background: transparent;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.85);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  text-align: left;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 1px solid ${PrimaryColor};
    outline-offset: 2px;
  }
`;

export const DeliveryAccordionOptional = styled.span`
  color: rgba(255, 255, 255, 0.5);
  font-weight: 400;
  letter-spacing: normal;
  text-transform: none;
`;

export const DeliveryAccordionChevron = styled.i`
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
`;

export const DeliveryOption = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin: 0;
  padding: 4px 0;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.7 : 1};
`;

export const DeliveryOptionText = styled.span`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DeliveryOptionTitle = styled.span`
  color: ${WhiteColor};
  font-size: 14px;
  font-weight: 600;
`;

export const DeliveryOptionDescription = styled.span`
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
`;

// Square checkbox, rose fill with a white tick when checked.
export const DeliveryOptionCheckbox = styled.input`
  appearance: none;
  -webkit-appearance: none;
  flex: 0 0 auto;
  position: relative;
  width: 18px;
  height: 18px;
  margin: 0;
  background: transparent;
  border: 1px solid ${LightGrayColor};
  border-radius: 3px;
  cursor: inherit;
  transition: background 0.2s ease, border-color 0.2s ease;

  &:checked {
    background: ${PrimaryColor};
    border-color: ${PrimaryColor};
  }

  &:checked::after {
    content: '';
    position: absolute;
    left: 5px;
    top: 1px;
    width: 6px;
    height: 11px;
    border: solid ${WhiteColor};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    box-shadow: 0 0 0 2px rgba(239, 66, 119, 0.4);
  }
`;

export const DeliveryOptionSettings = styled.div`
  padding: 12px 0 4px;
`;

export const DeliveryOptionDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 14px 0;
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.2px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-top: 1px solid rgba(255, 255, 255, 0.12);
  }
`;

export const ScheduleDayButtonRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
  width: 100%;
`;

export const ScheduleDayButton = styled.button`
  flex: 1 1 0;
  min-width: 0;
  padding: 6px 0;
  font-family: 'Roboto';
  font-size: 12px;
  font-weight: ${props => props.isSelected ? 700 : 400};
  line-height: 1.2;
  color: ${props => props.isSelected ? WhiteColor : LightGrayColor};
  background: ${props => props.isSelected ? PrimaryColor : SecondaryColor};
  border: 1px solid ${props => props.isSelected ? PrimaryColor : LightGrayColor};
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;

  &:hover:not(:disabled) {
    border-color: ${PrimaryColor};
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
